<template>
  <div>
    <!--    <app-content/>-->
    <router-view/>
  </div>
</template>

<script>
import AppContent from './pages/layout/Content';
import {startVersionCheck} from './utils/versionCheck';
import {applyBrandColorVars, clearBrandColorVars} from './utils/brandTheme';

export default {
  components: {AppContent},
  computed: {
    isLoggedIn() {
      return this.$store.getters['profile/loggedIn'];
    },
    brandColor() {
      return this.$store.getters['business_settings/branding']?.brand_color || null;
    },
  },
  watch: {
    // App.vue is the one component that stays mounted for the whole app
    // lifetime (router-view swaps underneath it), so it's the right place
    // to apply brand_color globally on document.documentElement - unlike
    // Sidebar.vue's own sidebar_color/sidebar_text_color overrides (scoped
    // to the sidebar element itself), Element Plus's primary-color
    // variables need to be visible to every component in the tree,
    // including ones like <el-button> that render outside the sidebar, and
    // teleported popper/dialog content Element Plus appends straight onto
    // <body>.
    brandColor: {
      immediate: true,
      handler(color) {
        if (color) {
          applyBrandColorVars(color);
        } else {
          clearBrandColorVars();
        }
      },
    },
  },
  mounted() {
    startVersionCheck();
  }
};
</script>

<style>
@media (max-width: 768px) {
  .el-range-editor.el-input__wrapper {
    width: 66px !important;
  }
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}

.el-picker-panel {
  max-width: 100vw !important;
  overflow-x: auto;
}

</style>
